<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <customer-field slot="pi_custname" :label="customLabel.pi_custname || '客户'" v-model="form.main.pi_custname" @select="onSelectCustomer" />
        <date-field
          slot="pi_date"
          :label="customLabel.pi_date || '单据日期'"
          v-model="form.main.pi_date"
        />
       
        <div class="weui-cell" slot="pi_otherkind">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pi_otherkind || "类型"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pi_otherkind }}
          </div>
        </div>
        <employee-field
          :label="customLabel.pi_seller || '业务员'"
          v-model="form.main.pi_seller"
          @select="onSelectEmployee"
          slot="pi_seller"
        />
        <department-field slot="pi_departmentname" :label="customLabel.pi_departmentname || '部门'" v-model="form.main.pi_departmentname" @select="onSelectDepartment" />
        <div class="weui-cell" slot="pi_sourcecode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pi_sourcecode || "项目单号"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pi_sourcecode }}
          </div>
        </div>
        <custom-field 
          :label="customLabel.pi_text1 || '自定义字段1'"
          v-model="form.main.pi_text1" :caller="caller" fieldName="pi_text1"
          slot="pi_text1" hidden="true"
        />
        <custom-field
          :label="customLabel.pi_text2 || '自定义字段2'"
          v-model="form.main.pi_text2" :caller="caller" fieldName="pi_text2"
          slot="pi_text2" hidden="true"
        />
        <custom-field 
          :label="customLabel.pi_text3 || '自定义字段3'"
          v-model="form.main.pi_text3" :caller="caller" fieldName="pi_text3"
          slot="pi_text3" hidden="true"
        />
        <custom-field 
          :label="customLabel.pi_text4 || '自定义字段4'"
          v-model="form.main.pi_text4" :caller="caller" fieldName="pi_text4"
          slot="pi_text4" hidden="true"
        />
        <custom-field 
          :label="customLabel.pi_text5 || '自定义字段5'"
          v-model="form.main.pi_text5" :caller="caller" fieldName="pi_text5"
          slot="pi_text5" hidden="true"
        />
      </custom-layout>

      <div class="weui-cells__group" v-for="(item,xindex) in form.items" :key="xindex">
        <div class="weui-cells__title">
          <span>产品{{xindex+1}}</span>
          <a href="javascript:;" class="header-tool" @click="removeItem(xindex)">
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
        <custom-layout :view-config="customViewConfig" position="detail1">
          <product-field slot="pr_detail" :label="customLabel.pr_detail || '物料名称'"
            v-model="item.productDTO.pr_detail"
            @select="onItemSelectProduct($event, item)"
          />
          <div class="weui-cell" v-if="item.pd_prodcode" slot="pd_prodcode">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.pd_prodcode || "物料编号"}}</label>
            </div>
            <div class="weui-cell__bd">{{item.pd_prodcode}}</div>
          </div>
          <div class="weui-cell" v-if="item.productDTO.pr_orispeccode" slot="pr_orispeccode">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.pr_orispeccode || "型号"}}</label>
            </div>
            <div class="weui-cell__bd">{{item.productDTO.pr_orispeccode}}</div>
          </div>
          <div class="weui-cell" v-if="item.productDTO.pr_spec" slot="pr_spec">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.pr_spec || "规格"}}</label>
            </div>
            <div class="weui-cell__bd">{{item.productDTO.pr_spec}}</div>
          </div>
          <warehouse-field v-model="item.pd_whname" @select="onItemSelectWarehouse($event, item)" />
          <div class="weui-cell" slot="pd_inqty">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.pd_inqty || "数量"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="item.pd_inqty"
                @change="calcItem(item)"
                placeholder="请填写"
              />
            </div>
            <div class="weui-cell__ft">{{item.productDTO.pr_unit}}</div>
          </div>
          <div class="weui-cell" slot="pr_unit_extra" v-if="item.productDTO.pr_unit_extra">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                "辅助数量"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                :value="$number.round(item.pd_inqty / item.productDTO.pr_denominator * item.productDTO.pr_numerator || 0, 3)"
                @input="oninputQty($event, item)"
                placeholder="请填写"
              />
            </div>
            <div class="weui-cell__ft">{{ item.productDTO.pr_unit_extra }}</div>
          </div>
          <div class="weui-cell" slot="pd_price">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.pd_price || "成本单价(元)"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="item.pd_price"
                @change="calcItem(item)"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell" v-if="item.pd_taxprice" slot="pd_total">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.pd_total || "金额(元)"}}</label>
            </div>
            <div class="weui-cell__bd">{{numberFormat(item.pd_total,'¥#,##0.00')}}</div>
          </div>
          <custom-field 
            :label="customLabel.pd_text1 || '自定义字段1'"
            v-model="item.pd_text1" :caller="caller" fieldName="pd_text1"
            slot="pd_text1" hidden="true"
          />
          <custom-field
            :label="customLabel.pd_text2 || '自定义字段2'"
            v-model="item.pd_text2" :caller="caller" fieldName="pd_text2"
            slot="pd_text2" hidden="true"
          />
          <custom-field 
            :label="customLabel.pd_text3 || '自定义字段3'"
            v-model="item.pd_text3" :caller="caller" fieldName="pd_text3"
            slot="pd_text3" hidden="true"
          />
          <custom-field 
            :label="customLabel.pd_text4 || '自定义字段4'"
            v-model="item.pd_text4" :caller="caller" fieldName="pd_text4"
            slot="pd_text4" hidden="true"
          />
          <custom-field 
            :label="customLabel.pd_text5 || '自定义字段5'"
            v-model="item.pd_text5" :caller="caller" fieldName="pd_text5"
            slot="pd_text5" hidden="true"
          />
        </custom-layout>
          <a
            href="javascript:"
            v-if="xindex==form.items.length-1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">提交</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >取消</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import CustomerField from "@/components/field/CustomerField.vue";
import DateField from "@/components/field/DateField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import DepartmentField from "@/components/field/DepartmentField.vue";
import ProductField from "@/components/field/ProductField.vue";
import WarehouseField from "@/components/field/WarehouseField.vue";
import process from "@/mixins/process.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  components: {
    CustomLayout,
    CustomerField,
    DateField,
    EmployeeField,
    DepartmentField,
    ProductField,
    WarehouseField,
    CustomField
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/storage/prodinout",
      codeField: "pi_inoutno",
      statusField: "pi_statuscode",
      caller: "PlmProjPick",
      xtype: "plm-projpick-formpanel",
      form: {
        main: {
          pi_class: "PLMPROJPICK",
          pi_otherkind:'研发领料',
          pi_custid: null,
          pi_custcode:null,
          pi_custname:null,
          pi_departmentname: null,
        },
        items: [
          {
            pd_inqty: 0,
            pd_price: 0,
            pd_total: 0,
            productDTO: {}
          }
        ]
      }
    };
  },
  methods: {
    /**
     * 选择供应商
     */
     onSelectCustomer(selection) {
      var me = this,
        main = me.form.main;
        main.pi_custid = selection.id;
        main.pi_custcode = selection.cu_code;
        main.pi_custname = selection.cu_name;
    },

    onSelectEmployee(selection) {
      var me = this,
        main = me.form.main;
      main.pi_sellerid = selection.id;
      main.pi_sellercode = selection.em_code;
      main.pi_seller = selection.em_name;
    },
    /**
     * 输入辅助数量
     */
    oninputQty(e, item) {
      item.pd_inqty = e.target.value / item.productDTO.pr_numerator * item.productDTO.pr_denominator
      this.calcItem(item)
    },
    /**
     * 选择部门
     */
    onSelectDepartment(selection) {
      var main = this.form.main;
      main.pi_departmentcode = selection.dp_code;
      main.pi_departmentid = selection.id;
    },
    /**
     * 选择明细产品
     */
    onItemSelectProduct(selection, item) {
      item.pd_prodid = selection.id;
      item.pd_prodcode = selection.pr_code;
      item.productDTO = Object.assign({}, selection);
    },
    /**
     * 选择明细仓库
     */
    onItemSelectWarehouse(selection, item) {
      item.pd_whid = selection.id;
      item.pd_whcode = selection.wh_code;
    },
    /**
     * 保存
     */
    save() {
      var me = this,
        items = me.form.items,
        checked;
      var count = 0;
      items.forEach(function(item) {
        if (!item.pd_prodid) {
          me.$weui.topTips(`第${count + 1}行产品未选择`, 2000);
          return false;
        } else if (!item.pd_whid) {
          me.$weui.topTips(`第${count + 1}行仓库未选择`, 2000);
          return false;
        } else if (!item.pd_inqty || item.pd_inqty <= 0) {
          me.$weui.topTips(`第${count + 1}行数量未填写`, 2000);
          return false;
        } else {
          count++;
          item.pd_pdno = count;
        }
      });
      checked = count == items.length;

      if (checked) {
        me.p_save();
      }
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({
        pd_inqty: 0,
        pd_price: 0,
        pd_total: 0,
        productDTO: {}
      });
    },
    /**
     * 计算单价、金额
     */
    calcItem(item) {
      var me = this;
      item.pd_inqty = me.$number.round(item.pd_inqty || 0, 3);
      item.pd_price = me.$number.round(item.pd_price || 0, 6);
      item.pd_total = me.$number.round(item.pd_inqty * item.pd_price, 2);
    }
  }
};
</script>